import { GAME_ASSET_SLUG } from "@/config/game";
import { extractColors } from "@/functions/extractCardColors";
import { cn } from "@/lib/utils";
import { getVersionAssetsSelector } from "@/redux/loadedContent/loadedContentSlice";
import type { GalleryBadge as Badge } from "@repo/shared/api";
import { GalleryVerticalEnd } from "lucide-react";
import { useSelector } from "react-redux";

const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
// Resized on the asset host: 2x the largest slot (64px on the set page). Rarity art is 576x800 otherwise.
const BADGE_WIDTH = 128;

export const GalleryBadge = ({
  badge,
  className,
}: {
  badge: Badge | null;
  className?: string;
}) => {
  const versionAssets = useSelector(getVersionAssetsSelector);
  const src =
    badge?.type === "club"
      ? `${assetsBaseUrl}/${GAME_ASSET_SLUG}/clubs/dark/${badge.id}.png`
      : badge?.type === "league"
        ? `${assetsBaseUrl}/${GAME_ASSET_SLUG}/leagues/dark/${badge.id}.png`
        : badge?.type === "rarity"
          ? extractColors({
              versionAssets,
              versionId: badge.id,
              metalId: 3,
            }).cardUrl
          : undefined;

  return (
    <div
      className={cn(
        "flex size-12 shrink-0 items-center justify-center",
        className,
      )}
    >
      {src ? (
        <img
          src={`${src}?width=${BADGE_WIDTH}`}
          alt=""
          loading="lazy"
          decoding="async"
          className="max-h-full max-w-full object-contain"
        />
      ) : (
        <GalleryVerticalEnd className="size-2/3 text-foreground-muted" />
      )}
    </div>
  );
};
